import { ReactNode, useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';

type LineagePanelProps<TProps extends Record<string, any>> = {
  isOpen: boolean;
  children: (props: TProps) => ReactNode;
  propsToFreeze: TProps | null;
  testId?: string;
};

export const LineagePanelView = <TProps extends Record<string, any>>({
  isOpen,
  children,
  propsToFreeze,
  testId = 'lineage-panel',
}: LineagePanelProps<TProps>) => {
  const [frozenProps, setFrozenProps] = useState<TProps | null>(propsToFreeze);
  useEffect(() => {
    if (!propsToFreeze || !isOpen) return;
    setFrozenProps(propsToFreeze);
  }, [propsToFreeze, isOpen]);

  return (
    <div
      data-is-panel-open={isOpen}
      data-testid={testId}
      className={twMerge(
        'overflow-x-none z-10 w-[450px] overflow-y-auto bg-bgMain shadow-hover transition-transform duration-300 motion-reduce:duration-0',
        !isOpen && 'absolute bottom-0 right-0 top-0 translate-x-full',
        isOpen && 'h-full translate-x-0',
      )}
    >
      {frozenProps && children(frozenProps)}
    </div>
  );
};
